import { Component, Input, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'aria-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

    inLoading$: BehaviorSubject<boolean>;

    // LOADER
    @Input() loaderTemplate: TemplateRef<any>;

    constructor(private loaderService: LoaderService) {
        this.inLoading$ = this.loaderService.loader$;
    }

}
